export const onKeyEnter = (e: any, func: () => void): void => {
    const keyEnter = e.key;
    if (keyEnter === "Enter") func();
};
